export class CreditCardEntryValidators
{
    public static isValidCVV(userInput:string):boolean
    {
        if( !userInput )
            return true;

        const len = userInput.length;

        return len >= 1 && len <= 3;
    }
}